module.exports = __webpack_public_path__ + "static/media/jquery-original-wordmark.8ec9bacf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jquery-original-wordmark.svg
// module id = 94
// module chunks = 0